var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.217 13.699h-.435a3.223 3.223 0 0 0-3.195 3.195v8.857a3.223 3.223 0 0 0 3.195 3.195h.435a3.223 3.223 0 0 0 3.195-3.195v-8.858a3.323 3.323 0 0 0-3.195-3.194Zm.436 3.195v8.857a.625.625 0 0 1-.581.581h-.436a.625.625 0 0 1-.581-.581v-8.858a.625.625 0 0 1 .581-.581h.436a.532.532 0 0 1 .581.582ZM17.927 6.73a3.286 3.286 0 0 0-3.34 3.34 3.286 3.286 0 0 0 3.34 3.339 3.286 3.286 0 0 0 3.34-3.34 3.286 3.286 0 0 0-3.34-3.339Zm-.726 3.34a.686.686 0 0 1 .726-.726.686.686 0 0 1 .726.726.686.686 0 0 1-.726.726.686.686 0 0 1-.726-.727Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17
  }))));
};
export default SvgInfo;